import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VueClipboard from 'vue-clipboard2'
import VueGooglePlaces from 'vue-google-places'
import VueDragDrop from 'vue-drag-drop';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueGooglePlaces)
Vue.use(Vuetify);
Vue.use(VueClipboard)
Vue.use(VueDragDrop);

Vue.use(VueMoment, {
  moment,
})

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#303F9F',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        anchor: '#00000A',
        awesome: '#0f2944'
      }
    }
  }
});
